import { isTagsEnabled } from '@/helpers/featureFlags'

export default [
  {
    path: '/',
    name: 'Homepage',
    meta: { requireAuth: true, requireFields: true },
    component: () => import('@/views/Home/index.vue'),
  },

  {
    path: '/changelog',
    meta: { requireAuth: true, requireFields: true },
    component: () => import('@/views/Home/Changelog/index.vue')
  },
  {
    path: '/cdp-hub/:feedId',
    meta: { requireAuth: true, requireFields: true },
    component: () => import('@/views/Home/components/Hub/FeedDetails.vue')
  },
  {
    path: '/settings',
    meta: { requireAuth: true, requireFields: true },
    component: () => import('@/views/Settings/index.vue'),
    redirect: '/settings/account',
    children: [
      { path: 'account', component: () => import('@/views/Settings/Account.vue') },
      { path: 'plans', name: 'SettingsPlans', component: () => import('@/views/Settings/Plans.vue') },
      { path: 'inventory', component: () => import('@/views/Settings/Inventory.vue') },
      { path: 'notifications', component: () => import('@/views/Settings/Notifications.vue') },
      { path: 'custom-fields', component: () => import('@/views/Settings/CustomFields.vue') },
      { path: 'templates', component: () => import('@/views/Settings/Templates.vue') },
      {
        path: 'tags',
        component: () => import('@/views/Settings/Tags.vue'),
        // Behind the `tags` flag, like the nav row that links here.
        beforeEnter: () => (isTagsEnabled() ? true : '/settings/account'),
      },
    ]
  },

  {
    path: '/upgrade-plans',
    name: 'UpgradePlans',
    meta: { requireAuth: true, requireFields: true },
    component: () => import('@/components/UpgradePlans/UpgradeWindow.vue')
  },

  {
    path: '/notifications',
    meta: { requireAuth: true, requireFields: true },
    component: () => import('@/views/Notifications/index.vue')
  },
  {
    path: '/sale-pick-list',
    // Always renders the upgraded Sale Pick List (the `sales_picklist_upgrade`
    // flag was removed); the Dispatcher keeps the legacy view importable.
    meta: { requireAuth: true, requireFields: true },
    component: () => import('@/views/SalePickList/Dispatcher.vue')
  },
  {
    path: '/sale-pick-list/print',
    // `fullScreen` makes App.vue render this route without MainLayout.
    meta: { requireAuth: true, requireFields: true, fullScreen: true },
    component: () => import('@/views/SalePickList/PrintView/index.vue')
  },
  {
    path: '/refer-friend',
    meta: { requireAuth: true, requireFields: true },
    component: () => import('./RouterView.vue')
  },
  {
    path: '/feedback',
    meta: { requireAuth: true, requireFields: true },
    component: () => import('./RouterView.vue')
  },
  {
    path: '/help',
    meta: { requireAuth: true, requireFields: true },
    component: () => import('./RouterView.vue')
  },
  {
    path: '/billing',
    meta: { requireAuth: true, requireFields: true },
    component: () => import('./RouterView.vue')
  },
  {
    path: '/desktop-app',
    meta: { requireAuth: true, requireFields: true },
    component: () => import('./RouterView.vue')
  },
  {
    path: '/pricing',
    meta: { requireAuth: true, requireFields: true },
    component: () => import('./RouterView.vue')
  },
  {
    path: '/exception-detected',
    meta: { requireAuth: true, requireFields: true },
    component: () => import('@/views/ExceptionDetectedPage.vue'),
  },
  {
    // In-app design-system gallery. Lighter-weight alternative to Storybook —
    // each atom / molecule / organism rendered with its key variants.
    // Adding a new component? Drop a `<DSSection>` block into the matching
    // atomic level in `views/DesignSystem/index.vue` + append the name to
    // the `NAV` array so it shows up in the sticky sidebar.
    path: '/design-system',
    name: 'DesignSystem',
    meta: { requireAuth: true, requireFields: true },
    component: () => import('@/views/DesignSystem/index.vue'),
  },
]
